<template>
  <div class="voucher-editor">
    <content-tabs v-model="activeTab"></content-tabs>
    <div v-show="activeTab.name === 'เนื้อหา'">
      <div class="row">
        <div class="content-body col-9 p-0">
          <el-input
            :value="title"
            type="text"
            class="input mb-3"
            maxlength="80"
            placeholder="หัวข้อ"
            show-word-limit
            @input="handleChangeInput('title', $event)"
          ></el-input>
          <div ref="editor" class="editor"></div>
        </div>
        <div class="content-meta col-3">
          <content-meta
            :value="value"
            :image-url="imageUrl"
            :thumbnail="thumbnail"
            @selectedImage="handleSelectImage($event)"
            @selectedThumbnail="handleSelectThumbnail($event)"
            @selectedPdf="handleSelectPdf($event)"
            @selectedLocation="handleSelectLocation($event)"
            @selectedImageAlbum="handleSelectImageAlbum($event)"
          ></content-meta>
        </div>
      </div>
    </div>
    <div v-show="activeTab.name === 'รายละเอียดกิจกรรม'">
      <content-event
        :value="value.event"
        :event-conditions="eventConditions"
        @setEvent="handleSetEvent"
        @setEventConditions="handleSetEventConditions($event)"
      ></content-event>
    </div>
  </div>
</template>

<script>
import { Input } from "element-ui"
import Quill from "quill"
import "quill/dist/quill.snow.css"
import { isEmpty } from "ramda"

import ContentEvent from "./ContentEvent"
import ContentMeta from "./ContentMeta"
import ContentTabs from "./ContentTabs"

export default {
  components: {
    ContentTabs,
    ContentMeta,
    ContentEvent,
    "el-input": Input,
  },
  props: {
    value: {
      type: null,
      default: undefined,
    },
    contentBodyJson: {
      type: null,
      default: undefined,
    },
    imageUrl: {
      type: null,
      default: undefined,
    },
    thumbnail: {
      type: null,
      default: undefined,
    },
    eventConditions: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      activeTab: { name: "เนื้อหา" },
      contentJson: null,
      contentHtml: "",
      editor: null,
    }
  },
  computed: {
    title() {
      return this.value.title
    },
    content() {
      return this.value.content
    },
  },
  watch: {
    contentBodyJson(value) {
      if (!this.contentJson) {
        this.contentJson = value
        this.editor.setContents(this.contentJson)
        this.getEditorContent()
        this.setContent()
      }
    },
  },
  mounted() {
    const container = this.$refs.editor
    this.editor = new Quill(container, {
      theme: "snow",
      formats: ["header", "bold", "underline", "blockquote"],
      modules: {
        toolbar: [
          [{ header: 1 }, { header: 2 }],
          ["bold", "underline"],
          ["blockquote"],
        ],
        keyboard: {
          bindings: {
            tab: {
              key: "Tab",
              handler: () => false,
            },
          },
        },
      },
      placeholder: "เริ่มพิมพ์ที่นี่",
    })

    this.editor.on("text-change", () => {
      this.getEditorContent()
      this.setContent()
    })
  },
  created() {
    this.setup()
  },
  methods: {
    setup() {
      this.setupContent()
    },
    setupContent() {
      if (!isEmpty(this.content)) {
        this.editor.setContents(this.content)
      }
    },
    setContent() {
      this.$emit("setContent", {
        contentJson: this.contentJson,
        contentHtml: this.contentHtml,
      })
    },
    getEditorContent() {
      this.contentJson = this.editor.getContents()
      this.contentHtml = this.editor.root.innerHTML
    },
    handleChangeInput(key, value) {
      this.$emit("input", { ...this.value, [key]: value })
    },
    handleSelectImage(value) {
      this.$emit("input", { ...this.value, imageFile: value.imageFile })
    },
    handleSelectThumbnail(value) {
      this.$emit("input", { ...this.value, thumbnailFile: value.thumbnailFile })
    },
    handleSelectPdf(value) {
      this.$emit("input", {
        ...this.value,
        fileName: value.name,
        pdfFile: value,
      })
    },
    handleSelectLocation(value) {
      this.$emit("input", {
        ...this.value,
        locationName: value.name,
        latitude: value.latitude,
        longitude: value.longitude,
      })
    },
    handleSelectImageAlbum(value) {
      this.$emit("input", { ...this.value, voucherAlbum: value })
    },
    handleSetEvent(value) {
      this.$emit("input", { ...this.value, event: value })
    },
    handleSetEventConditions(value) {
      this.$emit("setEventConditions", value)
    },
  },
}
</script>

<style scoped lang="scss">
.voucher-editor {
  .row {
    margin-left: 0px;
  }
}

.editor {
  overflow-y: scroll;
  max-height: calc(100vh - 400px);
}
</style>
